import React, { useEffect, useState } from "react";
import UnSubscribeEmailComponent from "./UnSubscribeEmail.component";
import * as HomeApi from "api/home/Home.api";
import { useNavigate, useSearchParams } from "react-router-dom";

const UnSubscribeEmailContainer = (props: any) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const agencyId = searchParams.get("agencyId");
  const [email, setEmail] = useState("");

  const unSubscribedEmail = async () => {
    try {
      const result = await HomeApi.updateUnSubscribedEmailInfo(+agencyId, {
        email: email,
        hasUnsubscribedEmail: true,
      });

      if (result && result.status === 200) {
        navigate("/unsubscribed/new-wannabe/done", { state: { email: email } });
      }
    } catch (err: any) {
      console.error(err);
      alert(err?.message || "이메일 수신 거부 처리 중 오류가 발생했습니다. 다시 시도해주세요.");
    }
  };

  useEffect(() => {
    if (!agencyId || isNaN(+agencyId)) {
      navigate("/");
    }
  }, []);

  return (
    <UnSubscribeEmailComponent
      {...props}
      unSubscribedEmail={unSubscribedEmail}
      email={email}
      setEmail={setEmail}
    />
  );
};

export default UnSubscribeEmailContainer;
